import { Component, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { AutomationViewGroup } from '@tokeet-frontend/automations'
import { AutomationLogsDialogService } from '@tv3/containers/automations/automation-logs/dialog/automation-logs-dialog.service'

@Component({
  selector: 'app-automations-dialog',
  templateUrl: './automations-dialog.component.html',
  styleUrls: ['./automations-dialog.component.scss'],
})
export class AutomationsDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AutomationsDialogComponent>,
    private automationLogsDialog: AutomationLogsDialogService
  ) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  onLogs(item: AutomationViewGroup) {
    this.automationLogsDialog.open(item)
  }
}
